import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { Theme, ThemeValidationParameters, ThemeValidationResult } from './types'

// actions
export const FETCH_THEME = 'theme/FETCH_THEME'
export const FETCH_THEME_SUCCESS = 'theme/FETCH_THEME_SUCCESS'
export const FETCH_THEME_FAIL = 'theme/FETCH_THEME_FAIL'

export const START_THEME_VALIDATION = 'theme/START_THEME_VALIDATION'
export const UPDATE_THEME_VALIDATION = 'theme/UPDATE_THEME_VALIDATION'

export const UPDATE_NEW_THEME = 'theme/UPDATE_NEW_THEME'
export const RESET_NEW_THEME = 'theme/RESET_NEW_THEME'

export const START_SAVING_THEME = 'theme/START_SAVING_THEME'
export const SAVING_THEME_SUCCESS = 'theme/SAVING_THEME_SUCCESS'
export const SAVING_THEME_FAIL = 'theme/SAVING_THEME_FAIL'

export const FETCH_THEME_INFO = 'theme/FETCH_THEME_INFO'
export const FETCH_THEME_INFO_SUCCESS = 'theme/FETCH_THEME_INFO_SUCCESS'
export const FETCH_THEME_INFO_FAIL = 'theme/FETCH_THEME_INFO_FAIL'

export const START_DELETING_THEME = 'theme/START_DELETING_THEME'
export const DELETING_THEME_SUCCESS = 'theme/DELETING_THEME_SUCCESS'
export const DELETING_THEME_FAIL = 'theme/DELETING_THEME_FAIL'

export const ThemeActions = {
  fetchThemes: () => createAction(FETCH_THEME),
  fetchThemessSuccess: (themes: Theme[]) => createAction(FETCH_THEME_SUCCESS, themes),
  startThemeValidation: (theme: ThemeValidationParameters) => createAction(START_THEME_VALIDATION, { theme }),
  updateThemeValidation: (result: ThemeValidationResult) => createAction(UPDATE_THEME_VALIDATION, result),
  updateNewTheme: (theme: ThemeValidationParameters) => createAction(UPDATE_NEW_THEME, { theme }),
  resetNewTheme: () => createAction(RESET_NEW_THEME),
  startSavingTheme: (theme: ThemeValidationParameters) => createAction(START_SAVING_THEME, { theme }),
  savingThemeSuccess: (theme: Theme) => createAction(SAVING_THEME_SUCCESS, theme),
  fetchThemeInfo: (entityId: string) => createAction(FETCH_THEME_INFO, entityId),
  fetchThemeInfoSuccess: (theme: Theme) => createAction(FETCH_THEME_INFO_SUCCESS, { theme }),
  fetchThemeInfoFail: () => createAction(DELETING_THEME_FAIL),
  startDeletingTheme: (entityId: string) => createAction(START_DELETING_THEME, entityId),
  deletinggThemeSuccess: () => createAction(DELETING_THEME_SUCCESS)
}

export type ThemeActions = ActionsUnion<typeof ThemeActions>
